<template>
  <div class="header">
    <div :class="{ 'modified-header': isPath !== '/' }" class="w">
      <div
        :class="{ 'modified-logo': isPath !== '/' }"
        class="logo"
        @click="home"
      >
        <img alt="" src="../assets/img/dulles/logo.png" />
      </div>
      <div :class="{ 'modified-title': isPath !== '/' }" class="title">
        <div
          :class="{
            'modified-designQuality':
              isPath == '/DesignQuality' || isPath == '/DesignQualityDetails'
          }"
          class="text"
          @click="designQualityBtn"
        >
          设计品质
        </div>
        <div
          class="text"
          @mouseenter="customizedMove"
          @mouseleave="customizedRemove"
        >
          <div
            :class="{
              'modified-customizeds':
                isPath == '/ShowerRoomDetail' && isType.type != 'edit'
            }"
          >
            定制淋浴房
          </div>
          <div
            :class="{ 'modified-customized': isPath !== '/' }"
            class="customized-details"
          >
            <!-- v-if="isCustomized"  -->
            <div v-if="isCustomized" class="w customized-details-content">
              <div
                v-for="(item, index) of selectList"
                :key="index"
                class="customized-details-content-text"
                @click="choiceShowerroom(item)"
              >
                <img :src="getImageURL(item.url)" alt="" class="img" />
                <div class="customized-details-content-bottom">
                  <div v-if="item.categoryNames" class="texts">
                    {{ item.categoryNames }}
                  </div>
                  <div v-else class="texts">{{ item.categoryName }}</div>
                  <img
                    alt=""
                    class="img-logo"
                    src="../assets/img/dulles/right.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="text"
          @mouseenter="moreproductMove"
          @mouseleave="moreproductRemove"
        >
          <div
            :class="{
              'modified-customizeds':
                (isPath == '/ShowerRoomList' ||
                  isPath == '/ShowerRoomDetail') &&
                isType.type == 'edit'
            }"
          >
            更多产品
          </div>
          <div
            :class="{ 'modified-customized': isPath !== '/' }"
            class="moreproduct-details"
          >
            <!-- v-if="isMoreproduct" -->
            <div v-if="isMoreproduct" class="w moreproduct-details-content">
              <div
                v-for="(item, index) of moreproductList"
                :key="index"
                class="moreproduct-details-content-text"
                @click="moreProducts(item)"
              >
                <img :src="getImageURL(item.url)" alt="" class="img" />
                <div class="moreproduct-details-content-bottom">
                  <span>{{ item.categoryName }}</span>
                  <img
                    alt=""
                    class="img-logo"
                    src="../assets/img/dulles/right.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{ 'modified-designQuality': isPath == '/AboutUs' }"
          class="text"
          @click="aboutUs"
        >
          关于我们
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import url from "../assets/img/dulles/测试下拉.jpg";
// import moreproducturl from "../assets/img/dulles/测试下拉产品.jpg";
import { baseURL } from "../utils/index.js";

export default {
  name: "Header",
  components: {},
  data() {
    return {
      isCustomized: false, //淋浴房显隐
      isMoreproduct: false, //更多产品显隐
      selectList: [], //定制淋浴房数据
      moreproductList: [] //更多产品数据
    };
  },

  created() {},
  computed: {
    isPath() {
      return this.$route.path;
    },
    isType() {
      return this.$route.query;
    }
  },
  mounted() {
    this.customizedShower();
    this.moreProductsBtn();
  },
  methods: {
    getImageURL(image) {
      return baseURL + image;
    },
    // 定制淋浴房
    customizedShower() {
      this.selectList = [];
      const data = {
        categoryLevel: 2,
        pid: 2, //淋浴房ID固定要写死
        deleteFlag: 2,
        isViewAll: 2
      };
      this.$http.post(`category/list`, data).then(res => {
        if (res.data.code == "success") {
          res.data.data.forEach(item => {
            if (item.categoryName && item.categoryName.includes("——")) {
              item.categoryNames = item.categoryName.split("——")[1];
            }
          });
          this.selectList = res.data.data;
        }
      });
    },
    // 更多产品
    moreProductsBtn() {
      this.moreproductList = [];
      const data = {
        categoryLevel: 1,
        pid: 2, //淋浴房ID写死的
        deleteFlag: 2
      };
      this.$http.post(`category/listNotShowRoom`, data).then(res => {
        if (res.data.code == "success") {
          // console.log('res.data.data',res.data.data);
          res.data.data.forEach(item => {
            // 2是写死的淋浴房，需修改
            if (item.id != 2) {
              this.moreproductList.push(item);
            }
          });
          // this.moreproductList = res.data.data;
        }
      });
    },
    // 返回首页
    home() {
      this.$router.push({ name: "home" });
    },
    // 设计品质跳转
    designQualityBtn() {
      this.$router.push({ name: "DesignQuality" });
    },
    // 定制淋浴房跳转
    choiceShowerroom(e) {
      this.$router.push({
        name: "ShowerRoomDetail",
        query: { id: e.id, name: e.categoryName, isShower: 1 }
      });
      this.isCustomized = false;
    },
    // 更多产品跳转
    moreProducts(e) {
      this.$router.push({
        name: "ShowerRoomList",
        query: { id: e.id, type: "edit" }
      });
      this.isMoreproduct = false;
    },
    // 定制淋浴房鼠标移入
    customizedMove() {
      this.isCustomized = true;
    },
    // 定制淋浴房鼠标移出
    customizedRemove() {
      this.isCustomized = false;
    },
    // 更多产品鼠标移入
    moreproductMove() {
      this.isMoreproduct = true;
    },
    // 更多产品鼠标移出
    moreproductRemove() {
      this.isMoreproduct = false;
    },
    // 关于我们
    aboutUs() {
      this.$router.push({ name: "AboutUs" });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;

  .logo {
    margin: 40px auto;
    text-align: center;
  }

  .title {
    // margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;

    .text {
      cursor: pointer;
      line-height: 44px;
      padding: 0 20px;

      .customized-details {
        position: absolute;
        top: 128px;
        left: 0;
        width: 100%;
        background-color: rgba(242, 242, 242, 0.9);
        z-index: 9999;

        .customized-details-content {
          padding: 0px 138px 30px;
          box-sizing: border-box;
          line-height: 0px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          .customized-details-content-text {
            width: 105px;
            margin-top: 30px;
            margin-right: 66px;
            padding: 10px 10px 6px;

            .img {
              width: 100%;
              // min-height: 105px;
              border-radius: 6px;
            }

            .customized-details-content-bottom {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 16px;
              color: #000000;
              margin-top: 8px;

              .texts {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 15px;
              }

              img {
                width: 16px;
              }
            }
          }

          .customized-details-content-text:hover {
            background-color: rgba(242, 242, 242, 0.5);
            border-radius: 6px;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
          }
        }
      }

      .moreproduct-details {
        position: absolute;
        top: 128px;
        left: 0;
        width: 100%;
        background-color: rgba(242, 242, 242, 0.9);
        z-index: 999;

        .moreproduct-details-content {
          padding: 0px 138px 30px;
          box-sizing: border-box;
          line-height: 0px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          .moreproduct-details-content-text {
            width: 180px;
            margin-top: 30px;
            margin-right: 40px;
            padding: 10px 10px 8px;

            .img {
              width: 100%;
              // min-height: 180px;
              border-radius: 6px;
            }

            .moreproduct-details-content-bottom {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 16px;
              color: #000000;
              margin-top: 8px;

              img {
                width: 16px;
              }
            }
          }

          .moreproduct-details-content-text:hover {
            background-color: rgba(242, 242, 242, 0.5);
            border-radius: 6px;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
          }
        }
      }
    }

    .text:hover {
      color: #907159;
    }
  }

  .title .text:first-child {
    margin-left: 0;
  }
}

.modified-header {
  display: flex;
  justify-content: space-between;
  align-items: initial;
}

.modified-logo {
  margin: 33px 0 !important;
}

.modified-title {
  align-items: initial !important;

  .text {
    line-height: 110px !important;
  }
}

.modified-customized {
  top: 110px !important;
}

.modified-customizeds {
  color: #907159;
}

.modified-designQuality {
  color: #907159;
  line-height: 110px;
}
</style>
